module.exports = __webpack_public_path__ + "img/sergeant-reason-icon2.29e5c88b.png";